import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component } from '@angular/core';

@Component({
  providers: [provideTranslocoScope('pricelists')],
  selector: 'lis-pricelists',
  imports: [TranslocoPipe, ],
  templateUrl: './pricelists.html',
  styleUrl: './pricelists.scss',
})
export class Pricelists {

}
